import React, { useState } from 'react';
import { useTheme } from '../contexts/ThemeContext';
import UserManagement from '../components/admin/UserManagement';
import MCPServerManagement from '../components/admin/MCPServerManagement';
import WorkflowManagement from '../components/admin/WorkflowManagement';
import AnalyticsDashboard from '../components/admin/AnalyticsDashboard';
import HistorialDashboard from '../components/admin/HistorialDashboard';
import StatsDashboard from '../components/admin/StatsDashboard';
import MCPProxyStatsDashboard from '../components/admin/MCPProxyStatsDashboard';

const AdminDashboard = () => {
  const [activeTab, setActiveTab] = useState('users');
  const { isDarkMode } = useTheme();

  const renderTabContent = () => {
    switch (activeTab) {
      case 'users':
        return (
          <div className="tab-content">
            <UserManagement />
          </div>
        );
      case 'servers':
        return (
          <div className="tab-content">
            <MCPServerManagement />
          </div>
        );
      case 'workflows':
        return (
          <div className="tab-content">
            <WorkflowManagement />
          </div>
        );
      case 'analytics':
        return (
          <div className="tab-content">
            <AnalyticsDashboard />
          </div>
        );
      case 'historial':
        return (
          <div className="tab-content">
            <HistorialDashboard />
          </div>
        );
      case 'stats':
        return (
          <div className="tab-content">
            <StatsDashboard />
          </div>
        );
      case 'mcp-proxy-stats':
        return (
          <div className="tab-content">
            <MCPProxyStatsDashboard />
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <div className="dashboard-page" style={{ paddingTop: '0' }}>
      <div className="container">
        {/* Header Section with Logo and Title */}
        <div style={{ marginBottom: '3rem' }}>
          {/* Centered Title */}
          <div style={{ textAlign: 'center', marginBottom: '1rem' }}>
            <h1 style={{ 
              fontSize: '3rem', 
              fontWeight: 'bold', 
              marginBottom: '1rem',
              color: isDarkMode ? 'white' : '#333'
            }}>
              Admin Dashboard
            </h1>
          </div>
          
          {/* Subheader text - centered on the page */}
          <div style={{ 
            marginBottom: '1.5rem'
          }}>
            <p style={{ 
              fontSize: '1.2rem', 
              color: isDarkMode ? '#D1D5DB' : '#666',
              maxWidth: '600px',
              margin: '0 auto',
              lineHeight: '1.6',
              textAlign: 'center'
            }}>
              Manage users, MCP servers, and workflows across the platform. Monitor system health, configure resources, and maintain the bioinformatics ecosystem.
            </p>
          </div>
          
          {/* Admin badge */}
          <div style={{ textAlign: 'center' }}>
            <div style={{ 
              display: 'inline-flex', 
              alignItems: 'center', 
              gap: '0.5rem',
              padding: '0.5rem 1rem',
              backgroundColor: isDarkMode ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.05)',
              borderRadius: '20px',
              border: isDarkMode ? '1px solid rgba(255, 255, 255, 0.3)' : '1px solid rgba(0, 0, 0, 0.1)'
            }}>
              <span style={{ 
                color: isDarkMode ? 'white' : '#333',
                fontSize: '0.9rem',
                fontWeight: '500'
              }}>
                Administrative Control Panel
              </span>
            </div>
          </div>
        </div>

        {/* Tab Navigation */}
        <div className="tab-navigation">
          <button
            className={`tab-button ${activeTab === 'users' ? 'active' : ''}`}
            onClick={() => setActiveTab('users')}
          >
            Users
          </button>
          <button
            className={`tab-button ${activeTab === 'servers' ? 'active' : ''}`}
            onClick={() => setActiveTab('servers')}
          >
            MCP Servers
          </button>
          <button
            className={`tab-button ${activeTab === 'workflows' ? 'active' : ''}`}
            onClick={() => setActiveTab('workflows')}
          >
            Workflows
          </button>
          <button
            className={`tab-button ${activeTab === 'analytics' ? 'active' : ''}`}
            onClick={() => setActiveTab('analytics')}
          >
            Analytics
          </button>
          <button
            className={`tab-button ${activeTab === 'stats' ? 'active' : ''}`}
            onClick={() => setActiveTab('stats')}
          >
            User Stats
          </button>
          <button
            className={`tab-button ${activeTab === 'mcp-proxy-stats' ? 'active' : ''}`}
            onClick={() => setActiveTab('mcp-proxy-stats')}
          >
            MCP Stats
          </button>
          <button
            className={`tab-button ${activeTab === 'historial' ? 'active' : ''}`}
            onClick={() => setActiveTab('historial')}
          >
            History
          </button>
        </div>

        {/* Tab Content */}
        {renderTabContent()}
      </div>
    </div>
  );
};

export default AdminDashboard;
